import React, { useState } from "react";

import FormControl from "@material-ui/core/FormControl";
import { Controller } from "react-hook-form";
import Select from 'react-select';

import { FormHelperText } from '@mui/material';

import { customStylesMultiSelect } from "../../DoctorMangement/StyledComponent";

export const MultipleSelectTypeInput = ({
  name,
  label,
  control,
  defaultValue,
  placeholder,
  children,
  errors,
  rules,
  height,
  width,
  onChange,
  selectArray = [],
  setValues,
  getValues,
  ...props
}) => {

  const [optionsArray, setOptionsArray] = useState([{ value: "*", label: "Select All" }, ...selectArray]);
  const handleSelection = (option, field, setValues)=>{
    const selectAllSelected = option.filter((item) => item.value == '*');
    if (selectAllSelected.length > 0) {
      field.onChange(selectArray);
      setValues(selectArray);
      setOptionsArray(selectArray);
    } 
    else {
      field.onChange(option);
      setValues(option);
      setOptionsArray([{ value: "*", label: "Select All" }, ...selectArray]);
    }
  }
  
  return (
    <div className="flex flex-col gap-2 ">
      <FormControl sx={{ m: 1 }}>
        <label >{label}</label>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          rules={rules}
          render={({ field }) => (
            <Select
              {...field}
              placeholder={placeholder}
              closeMenuOnSelect={false}
              options={optionsArray}
              isMulti
              style={{width:width}}
              onChange={(e) => {
              handleSelection(e, field, setValues);
              }}
              styles={customStylesMultiSelect}
              value={getValues || []}
            />
          )}
        />
        {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
      </FormControl>
    </div>
  );
};

